import { Descriptions } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogContent,
  DialogTitle,
  Dialog,
  CircularProgress,
  Box
} from '@mui/material';
import '../../pages/Licenses/licenses.scss';

interface Props {
  showModalAlgo: boolean;
  closeModal: Function;
  algorandTransaction: any;
}

const AlgoTransactionModal = ({
  showModalAlgo,
  closeModal,
  algorandTransaction
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog className='dialog' fullWidth open={showModalAlgo} onClose={() => closeModal()}>
      <DialogTitle>Algorand</DialogTitle>
      <DialogContent>
        {algorandTransaction?.transaction ? (
          <Descriptions title="" bordered>
            <Descriptions.Item span={3} label={t('WALLET')}>
              {algorandTransaction?.transaction
                ? algorandTransaction?.transaction['payment-transaction']
                  .receiver
                : '-'}
            </Descriptions.Item>
            <Descriptions.Item span={3} label={t('TOT_ALGO')}>
              {algorandTransaction?.transaction
                ? algorandTransaction?.transaction['payment-transaction']
                  .amount / 1000000
                : '-'}
            </Descriptions.Item>
            <Descriptions.Item span={3} label={t('DATA')}>
              {algorandTransaction?.transaction
                ? DateTime.fromMillis(
                  algorandTransaction?.transaction['round-time'] * 1000
                ).toFormat('dd-LL-yyyy HH:mm')
                : '-'}
            </Descriptions.Item>
          </Descriptions>
        ) : (
          <Box
            component="span"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AlgoTransactionModal;
